module.exports = __webpack_public_path__ + "static/media/PES.f13446ad.jpg";